<div class="flex flex-col gap-3 w-xl max-h-[90vh]">
  <h2>Sichtbarkeit einstellen</h2>
  <p>Entscheide, für welche Business Units Deine eingetragenen Erfahrungslevel sichtbar sein sollen.</p>

  <if-visibility-settings class="overflow-y-auto" [(selectedVisibilityGroups)]="selectedVisibilityGroups" />

  <p class="text-sm">Diese Einstellung kann jederzeit geändert werden.</p>

  <div class="flex justify-between gap-3 items-center w-full">
    <button data-testid="visibility-settings-dialog-cancel-btn" class="btn btn-secondary" (click)="onCancelButtonClick()">Abbrechen</button>
    <button data-testid="visibility-settings-dialog-save-btn" class="btn btn-primary" (click)="onConfirmButtonClick()">
      Sichtbarkeit anpassen
    </button>
  </div>
</div>
